export default `
query {
  getRegistrationClubFormFieldsOptions {
    options {
      attribute_code
      options {
        label,
        value
      }
    }
  }
}
`;
